import {DistanceProps} from 'modules/cities/types';
import useApiMutation from 'shared/hooks/use-api-mutation';
import useQueryHelpers from 'shared/hooks/use-query-helpers';
import companiesKeys from '../util/companies-keys';

const useEditCompanyDistance = (companyId: string, distanceId: string) => {
  const {update} = useQueryHelpers();

  const onSuccess = (data: DistanceProps) =>
    update(companiesKeys.distances(companyId), data);

  return useApiMutation<DistanceProps>({
    url: `/distances/${distanceId}`,
    method: 'PATCH',
    errorTitle: 'Erro ao atualizar distância',
    successTitle: 'Distância da empresa',
    successMessage: 'Distância atualizada com sucesso',
    redirectUrl: `/settings/companies/${companyId}/distances`,
    onSuccess,
  });
};

export default useEditCompanyDistance;
